import React from 'react';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopColumnsMobileStack from 'components/consumer/DesktopColumnsMobileStack/DesktopColumnsMobileStack';
import ImageTextBlock from 'components/essentials/ImageTextBlock';
import PropTypes from 'prop-types';

const ImageBlocksTwo = ({
  config: { heading, contentColumn1, contentColumn2 },
}) => (
  <FixedWidthContainer>
    {heading && heading.content && (
      <div className="text-3xl font-bold text-gray mt-0 mx-0 mb-10 text-left w-full">
        {heading.content}
      </div>
    )}

    <DesktopColumnsMobileStack>
      <ImageTextBlock {...contentColumn1} />
      <ImageTextBlock {...contentColumn2} />
    </DesktopColumnsMobileStack>
  </FixedWidthContainer>
);

ImageBlocksTwo.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.string,
    contentColumn1: PropTypes.string,
    contentColumn2: PropTypes.string,
  }),
};

export default ImageBlocksTwo;
